export default function Pin({ color='var(--accent)', ...props }) {
	return <svg width="15" height="16" {...props} viewBox="0 0 15 16" xmlns="http://www.w3.org/2000/svg" fill="none">
		<path
			d="M7.25 8.21667C9.30134 8.21667 10.9643 6.5452 10.9643 4.48334C10.9643 2.42147 9.30134 0.75 7.25 0.75C5.19866 0.75 3.53571 2.42147 3.53571 4.48334C3.53571 6.5452 5.19866 8.21667 7.25 8.21667ZM7.25 8.21667V14.75M7.25 14.75C10.8399 14.75 13.75 13.7053 13.75 12.4167C13.75 11.3597 11.7921 10.4668 9.10714 10.18M7.25 14.75C3.66015 14.75 0.75 13.7053 0.75 12.4167C0.75 11.3597 2.7079 10.4668 5.39286 10.18M7.71429 2.15C8.02381 2.15 8.73571 2.33667 9.10714 3.08334"
			stroke={color}
			strokeWidth="1.5"
			strokeLinecap="round"
		/>
	</svg>
}